<template functional>
    <header>
        <div v-if="props.pending">
            <b-spinner />
        </div>

        <b-button
            :disabled="props.pending"
            @click="listeners.click"
        >
            <fa :spin="props.pending" icon="sync" />
        </b-button>

        <no-results-found v-if="!props.pending && !props.itemsCount"/>
    </header>
</template>

<script>
    export default {
        name: 'PageHeader',
        props: {
            pending: {
                type: Boolean,
                default: false
            },
            itemsCount: {
                type: Number,
                default: null
            }
        }
    }
</script>

<style scoped>
    header {
        display: flex;
        flex-wrap: wrap;
    }

    header > div {
        text-align: center;
        flex-grow: 1;
    }

    button {
        margin: 0 0 1rem auto;
    }
</style>
